import { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';

import { ComponentBase, Size, TranslationKeys } from '../types';
import { SvgIconProps } from '../types/icon.types';

export type TextAreaSize = Exclude<Size, 'tiny'>;

export type TextAreaProps = Omit<
  DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >,
  'size' | 'placeholder'
> &
  Omit<ComponentBase, 'size'> & {
    error?: TranslationKeys;
    size?: TextAreaSize;
    labelKey?: TranslationKeys;
    helperTextKey?: TranslationKeys;
    helperTextValue?: object;
    RightIcon?: React.ComponentType<SvgIconProps>;
    LeftIcon?: React.ComponentType<SvgIconProps>;
  };

export const sizeClasses: Record<TextAreaSize, string> = {
  small: 'textarea-field-sm',
  medium: 'textarea-field-md',
  large: 'textarea-field-lg',
};
